import { getUrl } from './utils'

export const stories = [
  {
    id: 1,
    text: (
      <p>
        Радио в Мюнхене: с чего все начиналось. Редактор, историк русской службы
        Иван Толстой – о Радио Свободная Европа и Радио Свобода в первые годы
        после их основания.
      </p>
    ),
    img: getUrl('/images/videos/2_stories/spinoff_1.jpg'),
    youtube: '3tTpLHQ7mDU',
  },
  {
    id: 2,
    text: (
      <p>
        Первые эфиры: сотрудники русской службы рассказывают о том, как они
        начинали работать на &quot;Свободе&quot;, первых репортажах,
        командировках и особенностях профессии радиожурналиста.
      </p>
    ),
    img: getUrl('/images/videos/2_stories/spinoff_2.jpg'),
    youtube: 'OhtaCmsV4NY',
  },
  {
    id: 3,
    text: (
      <p>
        Свобода в Праге: журналисты русской службы рассказывают о переезде в
        Чехию и о том, как выглядела работа редакции изнутри.
      </p>
    ),
    img: getUrl('/images/videos/2_stories/spinoff_5.jpg'),
    youtube: 'Sk71VoW1QIA',
  },
  {
    id: 4,
    text: (
      <p>
        Журналист русской службы Радио Свобода Александра Вагнер рассказывает о
        своем опыте работы на войне.
      </p>
    ),
    img: getUrl('/images/videos/2_stories/spinoff_3.jpg'),
    youtube: '7ygTqyDKfSI',
  },
  {
    id: 5,
    text: (
      <p>
        Журналисты русской службы о работе московской редакции, последних эфирах
        в России и эвакуации в Латвию.
      </p>
    ),
    img: getUrl('/images/videos/2_stories/spinoff_5-inactive.jpg'),
  },
]
